import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../constants/storeLinks';
import type { Language } from '../i18n/language';

type StoreBadgesProps = {
  language: Language;
  className?: string;
};

const badgeCopy: Record<Language, {
  groupLabel: string;
  appStoreLabel: string;
  googlePlayLabel: string;
  appStoreAsset: string;
  googlePlayAsset: string;
  googlePlayImageClassName: string;
}> = {
  tr: {
    groupLabel: 'Uygulamayı mağazadan indir',
    appStoreLabel: 'App Store’dan indir',
    googlePlayLabel: 'Google Play’den indir',
    appStoreAsset: '/images/store-badges/app-store-tr.svg',
    googlePlayAsset: '/images/store-badges/google-play-tr.png',
    googlePlayImageClassName: 'h-[52px] w-auto max-w-none',
  },
  en: {
    groupLabel: 'Download the app',
    appStoreLabel: 'Download on the App Store',
    googlePlayLabel: 'Get it on Google Play',
    appStoreAsset: '/images/store-badges/app-store-en.svg',
    googlePlayAsset: '/images/store-badges/google-play-en.png',
    googlePlayImageClassName: 'h-[60px] w-auto max-w-none -mx-[10px]',
  },
};

const StoreBadges = ({ language, className = '' }: StoreBadgesProps) => {
  const copy = badgeCopy[language];
  const linkClassName = 'inline-flex h-10 shrink-0 items-center overflow-hidden rounded-[7px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-4';

  return (
    <div
      className={`flex flex-wrap items-center gap-x-2 gap-y-2 ${className}`.trim()}
      role="group"
      aria-label={copy.groupLabel}
    >
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        aria-label={copy.appStoreLabel}
      >
        <img
          src={copy.appStoreAsset}
          alt=""
          className="h-10 w-auto"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        aria-label={copy.googlePlayLabel}
      >
        <img
          src={copy.googlePlayAsset}
          alt=""
          className={copy.googlePlayImageClassName}
          loading="lazy"
          decoding="async"
        />
      </a>
    </div>
  );
};

export default StoreBadges;
